import InventoryFastCreationContainer from "./InventoryFastCreationContainer";

export default InventoryFastCreationContainer;
